module.exports = __webpack_public_path__ + "img/Patch11-2.6958d8db.webp";